import features from './Features';
import work from './Work';
import exhibitions from './Exhibitions';
import project from './Project';
import t404 from './404';

export default [features, work, exhibitions, project, t404];
